import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Checkbox,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import TablePagination from '../../components/molecules/TablePagination';
import CommonButton from '../../components/atoms/CommonButton';
import CommonButtonId from '../../components/atoms/CommonButtonId';
import ChangeSystemRatePriorityTextButton from '../../components/atoms/ChangeSystemRatePriorityTextButton';
import ToggleUseReceiptButton from '../../components/atoms/ToggleUseReceiptButton';
import ToggleLalapayEnableButton from '../../components/atoms/ToggleLalapayEnableButton';

const styles = {
  root: {
    marginTop: 15
  },
  overflow: {
    overflow: 'auto'
  },
  buttonContainer: {
    padding: '10px 26px 10px 26px',
    textAlign: 'right',
    backgroundColor: '#fff'
  },
  button: {
    margin: '5px 5px'
  },
  textRed: {
    color: '#F50057'
  },
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      budgets: state.budgets.list,
      totalCount: state.budgets.count,
      offset: 1
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('detailShop', 'setDetailShop', false),
  withHandlers({
    handleChangeRowsPerPage: props => event => {
      props.setRowsPerPage(parseInt(event.target.value, 10));
      props.handleChangePage(event, 1, parseInt(event.target.value, 10));
      // props.setRowsPerPage(event.target.value);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    progress,
    budgets,
    totalCount,
    rowsPerPage,
    page,
    handleChangePage,
    offset,
    onChangeBudgetStatus,
    onSendBudgetEmail,
    checkedBudgetIds,
    setCheckedBudgetIds,
    checkedSystemIds,
    setCheckedSystemIds,
    handleChangeRowsPerPage,
    selectedPage,
    loginToShashoku,
    openShashokuAddModal,
    onEditBudget,
    checkState,
    setCheckState,
    uncheckAll,
    setUseReceipt,
    useReceipt,
    onClickAction,
    onChangeToggleUseReceipt,
    detailShop,
    setDetailShop,
    shopName,
    setShopName,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    shopNameError,
    setShopNameError,
    bankNameError,
    setBankNameError,
    bankBranchNameError,
    setBankBranchNameError,
    bankAccountNumberError,
    setBankAccountNumberError,
    bankAccountHolderError,
    setBankAccountHolderError,
    hasDetail,
    setHasDetail,
    onCloseDialog,
    onChangeAllowDToF,
    lalapayEnable,
    setLalapayEnable,
    onChangeToggleLalapayEnable
  }) => {
    function checkAll() {
      setCheckState(true);
      const newCheckedBudgetIds = new Set(checkedBudgetIds);
      const newCheckedSystemIds = new Set(checkedSystemIds);
      budgets.forEach(el => {
        if (el.confirmFlag === 0 && el.shashokuBudgetId !== null)
          newCheckedBudgetIds.add(el.shashokuBudgetId);
        newCheckedSystemIds.add(el.connectSystemId);
      });
      setCheckedBudgetIds(newCheckedBudgetIds);
      setCheckedSystemIds(newCheckedSystemIds);
    }

    function handleChangeChecked(budgetId, systemId, isChecked) {
      const newCheckedBudgetIds = new Set(checkedBudgetIds);
      const newCheckedSystemIds = new Set(checkedSystemIds);
      if (isChecked) {
        if (budgetId) newCheckedBudgetIds.add(budgetId);
        newCheckedSystemIds.add(systemId);
      } else {
        if (budgetId) newCheckedBudgetIds.delete(budgetId);
        newCheckedSystemIds.delete(systemId);
      }
      setCheckedBudgetIds(newCheckedBudgetIds);
      setCheckedSystemIds(newCheckedSystemIds);
    }

    function onClickChangeMultiStatus() {
      onChangeBudgetStatus(Array.from(checkedBudgetIds));
    }

    function onClickSendMultiEmail() {
      onSendBudgetEmail(Array.from(checkedSystemIds));
    }

    const onClickChangeStatus = id => {
      const ids = [];
      ids.push(id);
      onChangeBudgetStatus(ids);
    };

    // console.log(budgets);
    const onClickSendBudgetEmail = id => {
      const ids = [];
      ids.push(id);
      onSendBudgetEmail(ids);
    };

    return (
      <div className={classes.root}>
        <div className={classes.buttonContainer}>
          <CommonButton
            className={classes.button}
            title="Add Bizmeshi"
            onClickAction={openShashokuAddModal}
          />
          <CommonButton
            className={classes.button}
            title={checkState ? '全て選択解除' : '全て選択'}
            onClickAction={checkState ? uncheckAll : checkAll}
          />
          <CommonButton
            className={classes.button}
            title="一括更新 (送信)"
            onClickAction={onClickChangeMultiStatus}
          />
          <CommonButton
            className={classes.button}
            title="一括メール送信"
            onClickAction={onClickSendMultiEmail}
          />
        </div>
        <div className={classes.scrollTable}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>システムID</TableCell>
                <TableCell>会社名</TableCell>
                <TableCell>住所</TableCell>
                <TableCell />
                <TableCell>手数料率</TableCell>
                <TableCell>LaLaPAY利用機能</TableCell>
                <TableCell>レシート利用機能</TableCell>
                <TableCell>D〜Fチケット</TableCell>
                <TableCell>予算</TableCell>
                <TableCell />
                <TableCell>入金確認日</TableCell>
                <TableCell>更新状況</TableCell>
                <TableCell>更新日時</TableCell>
                <TableCell />
                <TableCell />
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {budgets &&
                budgets.map(budget => {
                  const params = {
                    connectSystemId: budget.connectSystemId,
                    useReceipt: budget.ocrShopReceiptEnable,
                    ocrShopId: budget.ocrShopId,
                    lalapayEnable: budget.lalapayEnable,
                    lalapayShopId: budget.lalapayShopId
                    // useReceipt: 1,
                    // ocrShopId: 21551
                  };

                  return (
                    <TableRow key={budget.connectSystemId}>
                      <TableCell>
                        {
                          <Checkbox
                            color="primary"
                            checked={checkedSystemIds.has(
                              budget.connectSystemId
                            )}
                            onChange={e =>
                              handleChangeChecked(
                                budget.shashokuBudgetId,
                                budget.connectSystemId,
                                e.target.checked
                              )
                            }
                          />
                        }
                      </TableCell>
                      <TableCell>{budget.connectSystemId}</TableCell>
                      <TableCell>{budget.connectSystemName}</TableCell>
                      <TableCell>{budget.connectSystemAddress}</TableCell>
                      <TableCell>
                        {budget.budgetAmountOld &&
                        budget.budgetAmountOld > 0 &&
                        budget.confirmFlag !== 1 &&
                        budget.notApproveAmount > 0
                          ? `変更前\n¥${budget.budgetAmountOld.toLocaleString()}`
                          : ''}
                      </TableCell>
                      <TableCell>
                        <ChangeSystemRatePriorityTextButton
                          key={budget.connectSystemId}
                          connectSystemId={budget.connectSystemId}
                          systemRatePriority={budget.systemInvoiceRate}
                          onClickAction={onClickAction}
                        />
                      </TableCell>
                      <TableCell>
                        <ToggleLalapayEnableButton
                          params={params}
                          setLalapayEnable={setLalapayEnable}
                          lalapayEnable={lalapayEnable}
                          onChangeToggleLalapayEnable={
                            onChangeToggleLalapayEnable
                          }
                          progress={progress}
                          detailShop={detailShop}
                          setDetailShop={setDetailShop}
                          shopName={shopName}
                          setShopName={setShopName}
                          bankName={bankName}
                          setBankName={setBankName}
                          bankBranchName={bankBranchName}
                          setBankBranchName={setBankBranchName}
                          bankAccountType={bankAccountType}
                          setBankAccountType={setBankAccountType}
                          bankAccountTypeStr={bankAccountTypeStr}
                          setBankAccountTypeStr={setBankAccountTypeStr}
                          bankAccountNumber={bankAccountNumber}
                          setBankAccountNumber={setBankAccountNumber}
                          bankAccountHolder={bankAccountHolder}
                          setBankAccountHolder={setBankAccountHolder}
                          shopNameError={shopNameError}
                          setShopNameError={setShopNameError}
                          bankNameError={bankNameError}
                          setBankNameError={setBankNameError}
                          bankBranchNameError={bankBranchNameError}
                          setBankBranchNameError={setBankBranchNameError}
                          bankAccountNumberError={bankAccountNumberError}
                          setBankAccountNumberError={setBankAccountNumberError}
                          bankAccountHolderError={bankAccountHolderError}
                          setBankAccountHolderError={setBankAccountHolderError}
                          onCloseDialog={onCloseDialog}
                          setHasDetail={setHasDetail}
                          hasDetail={hasDetail}
                        />
                      </TableCell>
                      <TableCell>
                        <ToggleUseReceiptButton
                          params={params}
                          setUseReceipt={setUseReceipt}
                          useReceipt={useReceipt}
                          onChangeToggleUseReceipt={onChangeToggleUseReceipt}
                          progress={progress}
                          detailShop={detailShop}
                          setDetailShop={setDetailShop}
                          shopName={shopName}
                          setShopName={setShopName}
                          bankName={bankName}
                          setBankName={setBankName}
                          bankBranchName={bankBranchName}
                          setBankBranchName={setBankBranchName}
                          bankAccountType={bankAccountType}
                          setBankAccountType={setBankAccountType}
                          bankAccountTypeStr={bankAccountTypeStr}
                          setBankAccountTypeStr={setBankAccountTypeStr}
                          bankAccountNumber={bankAccountNumber}
                          setBankAccountNumber={setBankAccountNumber}
                          bankAccountHolder={bankAccountHolder}
                          setBankAccountHolder={setBankAccountHolder}
                          shopNameError={shopNameError}
                          setShopNameError={setShopNameError}
                          bankNameError={bankNameError}
                          setBankNameError={setBankNameError}
                          bankBranchNameError={bankBranchNameError}
                          setBankBranchNameError={setBankBranchNameError}
                          bankAccountNumberError={bankAccountNumberError}
                          setBankAccountNumberError={setBankAccountNumberError}
                          bankAccountHolderError={bankAccountHolderError}
                          setBankAccountHolderError={setBankAccountHolderError}
                          onCloseDialog={onCloseDialog}
                          setHasDetail={setHasDetail}
                          hasDetail={hasDetail}
                        />
                      </TableCell>
                      <TableCell>
                        <Select
                          value={budget.allowDToF}
                          onChange={e =>
                            onChangeAllowDToF(
                              budget.connectSystemId,
                              e.target.value
                            )
                          }
                          inputProps={{ 'aria-label': 'Without label' }}
                        >
                          <MenuItem value={0}>利用しない</MenuItem>
                          <MenuItem value={1}>利用する</MenuItem>
                        </Select>
                      </TableCell>
                      <TableCell>
                        {budget.budgetAmount !== null ? (
                          `¥${budget.budgetAmount.toLocaleString()}`
                        ) : (
                          <span className={classes.textRed}>予算未設定</span>
                        )}
                      </TableCell>
                      <TableCell>
                        <CommonButtonId
                          className={classes.button}
                          title="編集"
                          onClickAction={() => onEditBudget(budget)}
                          disabled={budget.confirmFlag !== 1}
                        />
                      </TableCell>
                      <TableCell>{budget.confirmAt}</TableCell>
                      {budget.confirmFlag === 0 && (
                        <TableCell>未入金</TableCell>
                      )}
                      {budget.confirmFlag === 1 && (
                        <TableCell>入金済</TableCell>
                      )}
                      {budget.confirmFlag === null && (
                        <TableCell>予算未設定</TableCell>
                      )}
                      <TableCell>{budget.updatedAt}</TableCell>
                      <TableCell>
                        <CommonButtonId
                          id={budget.shashokuBudgetId}
                          className={classes.button}
                          title="入金OK"
                          disabled={budget.confirmFlag !== 0}
                          onClickAction={() =>
                            onClickChangeStatus(budget.shashokuBudgetId)
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <CommonButtonId
                          className={classes.button}
                          title="入金NG"
                          onClickAction={() =>
                            onClickSendBudgetEmail(budget.connectSystemId)
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <CommonButtonId
                          id={budget.url}
                          className={classes.button}
                          title="会社としてログイン"
                          onClickAction={() =>
                            loginToShashoku(budget.connectSystemId)
                          }
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </div>

        <TablePagination
          hidden
          searchResults={budgets}
          rowsPerPage={rowsPerPage}
          page={page - 1}
          handleChangePage={(e, p) => handleChangePage(e, p + 1)}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          totalCount={totalCount}
          offset={offset}
          selectedPage={selectedPage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
